<template>
<div class="circle_button">
    <!--<div class="circle_center_button" :class="{'center_active_button': active_button == '-1'}" @touchstart="songerHandler('start')"  @touchend="songerHandler('end')">-->
    <!--<img src="../../static/img/yuyin.svg" alt="">-->
    <!--</div>-->
    <div class="line_1"></div>
    <div class="line_2"></div>
    
    <div class="circle_center_button"></div>

    <ul>
        <li :class="{'active_button': active_button == 'left'}">
            <a @touchstart.stop.prevent="click_handler('start', 'left',$event)"  @touchend.stop.prevent="click_handler('end', 'left',$event)">
          <span class="point"></span>
          <span class="point_dec point_dec_l"></span>
        </a>
        </li>
        <li :class="{'active_button': active_button == 'up'}">
            <a @touchstart.stop.prevent="click_handler('start', 'up',$event)"  @touchend.stop.prevent="click_handler('end', 'up',$event)">
          <span class="point"></span>
          <span class="point_dec point_dec_t"></span>
        </a>
        </li>
        <li :class="{'active_button': active_button == 'right'}">
            <a @touchstart.stop.prevent="click_handler('start', 'right',$event)"  @touchend.stop.prevent="click_handler('end', 'right',$event)">
          <span class="point"></span>
          <span class="point_dec point_dec_r"></span>
        </a>
        </li>
        <li :class="{'active_button': active_button == 'down'}">
            <a @touchstart.stop.prevent="click_handler('start', 'down',$event)"  @touchend.stop.prevent="click_handler('end', 'down',$event)">
          <span class="point"></span>
          <span class="point_dec point_dec_b"></span>
        </a>
        </li>
    </ul>
</div>
</template>

<script>
export default {
    name: "circleButton",
    data() {
        return {
            active_button: ''
        }
    },
    computed: {},
    components: {},
    created() {

    },
    mounted() {

    },
    methods: {
        click_handler(type, index, e) {
            // console.log(e);
            // e.preventDefault();
            if (type == 'start') {
                this.active_button = index;
            } else {
                this.active_button = '';
            }
            this.$emit('click', {
                type: type,
                index: index
            });
        },
        // 语音通话
        songerHandler(type) {
            if (type == 'start') {
                this.active_button = '-1';
            } else {
                this.active_button = '';
            }
            this.$emit('sound_click', type);
        }
    },
    watch: {}
}
</script>

<style lang="less">
/* @import url("../../../assets/less-css/flexible.less"); */

@import url('../../assets/less-css/flexible.less');

* {
    margin: 0;
    padding: 0;
}

.circle_button {
    /*margin: 50px;*/
    .w(288);
    .h(288);
    position: relative;
    background-color: #cccccc;
    /*background-color: red;*/
    box-shadow: 4px 4px 19px 0px rgba(231, 231, 231, 0.5);
    border: solid 1px #dddddd;
    border-radius: 50%;
}

.circle_button .circle_center_button {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    margin: auto;
    // width: 122px;
    // height: 122px;
    .w(122);
    .h(122);
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background-color: #ffffff;
    border: solid 4px #eeeeee;
    display: flex;
    align-items: center;
    justify-content: center;
}

.circle_button .point {
    position: absolute;
    top: 16%;
    left: 16%;
    z-index: 3;
    // width: 8px;
    // height: 8px;
    .w(8);
    .h(8);
    border-radius: 50%;
    background-color: #e7e7e7;
}

.circle_button .point_dec {
    position: absolute;
    top: 16%;
    left: 16%;
    width: 0px;
    height: 0px;
    border: 16 / @baseFontSize * 1rem solid #cccccc;
}

.circle_button li {
    list-style: none;
    position: absolute;
    /*font-size: 1.5em;*/
    /*width: 10em;*/
    /*height: 10em;*/
    // width: 144px;
    // height: 144px;
    .w(144);
    .h(144);
    -webkit-transform-origin: 100% 100%;
    -moz-transform-origin: 100% 100%;
    -ms-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
    overflow: hidden;
    /*left: 50%;*/
    /*top: 50%;*/
    /*margin-top: -1.3em;*/
    /*margin-left: -10em;*/
    -webkit-transition: border .3s ease;
    -moz-transition: border .3s ease;
    transition: border .3s ease;
}

.circle_button li a {
    display: block;
    /*font-size: 1.18em;*/
    /*height: 14.5em;*/
    /*width: 14.5em;*/
    // height: 288px;
    // width: 288px;

    .w(288);
    .h(288);
    position: absolute;
    /*bottom: -7.25em;*/
    /*right: -7.25em;*/
    border-radius: 50%;
    text-decoration: none;
    color: #fff;
    padding-top: 0px;
    text-align: center;
    /*-webkit-transform: skew(-50deg) rotate(-70deg) scale(1);*/
    /*-ms-transform: skew(-50deg) rotate(-70deg) scale(1);*/
    /*-moz-transform: skew(-50deg) rotate(-70deg) scale(1);*/
    transform: skew(0deg) rotate(0deg) scale(1);
    -webkit-backface-visibility: hidden;
    -webkit-transition: opacity 0.3s, color 0.3s;
    -moz-transition: opacity 0.3s, color 0.3s;
    transition: opacity 0.3s, color 0.3s;
}

.circle_button li:nth-of-type(1) {
    transform: rotate(-45deg) skew(0deg);
}

.circle_button li:nth-of-type(1) a {
    background-color: #ffffff;
}

.circle_button li:nth-of-type(1) .point_dec_l {
    border-top-color: transparent;
    border-left-color: transparent;
    border-bottom-color: transparent;
    transform: rotate(45deg) scale(1.4, 1);
}

.circle_button li:nth-of-type(2) {
    transform: rotate(45deg) skew(0deg);

}

.circle_button li:nth-of-type(2) a {
    /*background-color: hsla(0, 88%, 65%, 1);*/
    background-color: #ffffff;
}

.circle_button li:nth-of-type(2) .point_dec_t {
    border-top-color: transparent;
    border-left-color: transparent;
    border-bottom-color: transparent;
    transform: rotate(45deg) scale(1.4, 1);
}

.circle_button li:nth-of-type(3) {
    transform: rotate(135deg) skew(0deg);

}

.circle_button li:nth-of-type(3) a {
    background-color: #ffffff;
    /*background-color: hsla(0, 88%, 63%, 1);*/
}

.circle_button li:nth-of-type(3) .point_dec_r {
    border-top-color: transparent;
    border-left-color: transparent;
    border-bottom-color: transparent;
    transform: rotate(45deg) scale(1.4, 1);
}

.circle_button li:nth-of-type(4) {
    transform: rotate(225deg) skew(0deg);

}

.circle_button li:nth-of-type(4) a {
    background-color: #ffffff;
    /*background-color: hsla(0, 88%, 65%, 1);*/
}

.circle_button li:nth-of-type(4) .point_dec_b {
    border-top-color: transparent;
    border-left-color: transparent;
    border-bottom-color: transparent;
    transform: rotate(45deg) scale(1.4, 1);
}

.circle_button .center_active_button {
    background-color: #f8f8f8;
}

.circle_button .active_button .point {
    background-color: #38a2f0;
}

.circle_button .active_button .point_dec {
    border-color: #999999;
}

.circle_button .active_button a {
    background-color: #f8f8f8 !important;
}

.circle_button .line_1 {
    position: absolute;
    top: 50%;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 1px;
    background: #cccccc;
    transform: rotate(45deg) scaleY(0.5);
}

.circle_button .line_2 {
    position: absolute;
    top: 50%;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 1px;
    background: #cccccc;
    transform: rotate(-45deg) scaleY(0.5);
}
</style>

<style>
@media screen and (min-width: 320px) and (max-width: 400px) {
    .circle_button {
        width: 150px;
        height: 150px;
    }

    .circle_button .circle_center_button {
        width: 50%;
        height: 50%;
    }

    .circle_button li {
        width: 50%;
        height: 50%;
    }

    .circle_button li a {
        width: 150px;
        height: 150px;
    }

    .circle_button .point_dec {
        border: 8px solid #cccccc;
    }

    .circle_button .point {
        width: 6px;
        height: 6px;
    }
}

@media screen and (min-width: 400px) and (max-width: 480px) {
    .circle_button {
        width: 170px;
        height: 170px;
    }

    .circle_button .circle_center_button {
        width: 50%;
        height: 50%;
    }

    .circle_button li {
        width: 50%;
        height: 50%;
    }

    .circle_button li a {
        width: 170px;
        height: 170px;
    }

    .circle_button .point_dec {
        border: 10px solid #cccccc;
    }

    .circle_button .point {
        width: 7px;
        height: 7px;
    }
}

@media screen and (min-width: 480px) and (max-width: 640px) {
    .circle_button {
        width: 200px;
        height: 200px;
    }

    .circle_button .circle_center_button {
        width: 50%;
        height: 50%;
    }

    .circle_button li {
        width: 50%;
        height: 50%;
    }

    .circle_button li a {
        width: 200px;
        height: 200px;
    }

    .circle_button .point_dec {
        border: 12px solid #cccccc;
    }

    .circle_button .point {
        width: 8px;
        height: 8px;
    }
}

@media screen and (min-width: 640px) {
    .circle_button {
        width: 220px;
        height: 220px;
    }

    .circle_button .circle_center_button {
        width: 50%;
        height: 50%;
    }

    .circle_button li {
        width: 50%;
        height: 50%;
    }

    .circle_button li a {
        width: 220px;
        height: 220px;
    }

    .circle_button .point_dec {
        border: 13px solid #cccccc;
    }

    .circle_button .point {
        width: 8px;
        height: 8px;
    }
}
</style>
